import React, { useState, useEffect } from 'react';
import { getOperarioNombre } from '../utils/helpers';

const OperationFinishForm = ({ operaciones, operarios, onFinishOperation, initialOperationId, clearInitialOperationId }) => {
  const initiatedOperations = operaciones.filter(op => op.estado === 'iniciada' || op.estado === 'pausada');
  const [selectedOperationId, setSelectedOperationId] = useState('');
  const [unitsProduced, setUnitsProduced] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (initialOperationId) {
      setSelectedOperationId(initialOperationId);
      clearInitialOperationId(); // Clear it after setting
    }
  }, [initialOperationId, clearInitialOperationId]);

  const handleFinish = () => {
    if (!selectedOperationId || unitsProduced === '' || isNaN(unitsProduced) || parseInt(unitsProduced) <= 0) {
      setMessage('Por favor, selecciona una operación y unidades válidas.');
      return;
    }
    onFinishOperation(selectedOperationId, parseInt(unitsProduced));
    const finishedOp = initiatedOperations.find(op => op.id === selectedOperationId);
    setMessage(`Operación ${finishedOp ? finishedOp.producto : ''} terminada con ${unitsProduced} unidades.`);
    setSelectedOperationId('');
    setUnitsProduced('');
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg max-w-md mx-auto transition-colors duration-300">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Terminar Operación</h2>
      <div className="mb-4">
        <label htmlFor="operation-select" className="block text-gray-700 text-base font-medium mb-2">Selecciona Operación en Curso/Pausada:</label>
        <select
          id="operation-select"
          value={selectedOperationId}
          onChange={(e) => setSelectedOperationId(e.target.value)}
          className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-black text-base transition"
        >
          <option value="">-- Selecciona una operación --</option>
          {initiatedOperations.map(op => (
            <option key={op.id} value={op.id}>
              {op.producto} ({getOperarioNombre(op.operarioId, operarios)}) - {op.estado.charAt(0).toUpperCase() + op.estado.slice(1)}
            </option>
          ))}
        </select>
      </div>
      <div className="mb-6">
        <label htmlFor="units-input" className="block text-gray-700 text-base font-medium mb-2">Unidades Fabricadas:</label>
        <input
          id="units-input"
          type="number"
          placeholder="Ej. 150"
          value={unitsProduced}
          onChange={(e) => setUnitsProduced(e.target.value)}
          className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-black text-base transition"
        />
      </div>
      <button
        onClick={handleFinish}
        className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors font-semibold text-lg"
      >
        Terminar Operación
      </button>
      {message && (
        <p className="mt-4 text-center text-sm text-gray-600">{message}</p>
      )}
    </div>
  );
};

export default OperationFinishForm;